import React from "react";
import InputField from "../../../../../../components/InputField";
import "./InputEntry.scss";

export default function InputEntry({
  title, prefix, numeric, prefixValue, numericValue, onPrefixValueChange, onNumericValueChange, readOnly
}: any) {
  return (
    <div className="id-input-entry">
      <div className="title">
        {title}
      </div>
      <div className="input-wrapper">
        <InputField
          value={prefixValue}
          readOnly={readOnly}
          handleChange={(e) => onPrefixValueChange(e.target.value)}
        />
        <div className="desc">
          {prefix}
        </div>
      </div>
      <div className="input-wrapper">
        <InputField
          type="number"
          value={numericValue}
          readOnly={readOnly}
          handleChange={(e) => onNumericValueChange(e.target.value)}
        />
        <div className="desc">
          {numeric}
        </div>
      </div>
    </div>
  )
}